import { render, staticRenderFns } from "./wjEditTask.vue?vue&type=template&id=0a2d6d5a&"
import script from "./wjEditTask.vue?vue&type=script&lang=js&"
export * from "./wjEditTask.vue?vue&type=script&lang=js&"
import style0 from "./wjEditTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports